import axios from "axios";

const API_URL = process.env.REACT_APP_API_ENDPOINT;

class ContractService {
    getAll() {
        return axios.get(`${API_URL}/contract/all`, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')?.trim()}`
            }
        });
    }
    getAllType() {
        return axios.get(`${API_URL}/contract/type`, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')?.trim()}`
            }
        });
    }
    getLastNumber() {
        return axios.get(`${API_URL}/contract/lastNumber`, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')?.trim()}`
            }
        });
    }
    getContract(id) {
        return axios.get(`${API_URL}/contract/view/${id}`, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')?.trim()}`
            }
        });
    }
    getContractDup(id) {
        return axios.get(`${API_URL}/contract/duplicate/${id}`, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')?.trim()}`
            }
        });
    }
    getPayments(id) {
        return axios.get(`${API_URL}/contract/${id}/payments`, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')?.trim()}`
            }
        });
    }
    getFilter(contractFilter) {
        return axios.post(`${API_URL}/contract/filter`, contractFilter, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')?.trim()}`
            }
        });
    }
    getFilterClient(search,id_client) {
        return axios.get(`${API_URL}/contract/getFilterClient`, {
            params: {
                search: search,
                id_client: id_client,
            },
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')?.trim()}`
            }
        });
    }
    getFilterEvent(search,id_event) {
        return axios.get(`${API_URL}/contract/getFilterEvent`, {
            params: {
                search: search,
                id_event: id_event,
            },
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')?.trim()}`
            }
        });
    }
    add(contract) {
        return axios.post(`${API_URL}/contract/new`, contract, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')?.trim()}`
            }
        });
    }
    update(contract) {
        return axios.put(`${API_URL}/contract/update`, contract, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')?.trim()}`
            }
        });
    }
    updatePayments(id,payments) {
        return axios.put(`${API_URL}/contract/${id}/payments`, payments, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')?.trim()}`
            }
        });
    }
    getPdf(id,type) {
        return axios.get(`${API_URL}/contract/${id}/getPdf`, {
            responseType: 'blob',
            params: {
                type: type,
            },
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')?.trim()}`,
              'Content-Type': 'application/pdf'
            }
        });
    }
    checkFile(id) {
        return axios.get(`${API_URL}/contract/checkFile`, {
            params: {
                id: id,
            },
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')?.trim()}`
            }
        });
    }
    getPreview(id) {
        return axios.get(`${API_URL}/contract/${id}/pdf-preview`, {
            responseType: 'blob',
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')?.trim()}`,
              'Content-Type': 'application/pdf'
            }
        });
    }
    upload(formData) {
        return axios.post(`${API_URL}/contract/upload-signed`, formData, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')?.trim()}`,
              'Content-Type': 'multipart/form-data'
            }
        });
    }
    uploadProject(formData) {
        return axios.post(`${API_URL}/contract/upload-project`, formData, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')?.trim()}`,
              'Content-Type': 'multipart/form-data'
            }
        });
    }
}

export default new ContractService();